import '@js/components/liveChat';
// import mobileNavigation from '@js/components/mobileNavigation';
import { desktopNavigation } from '@js/components/desktopNavigation';
import '@js/entrypoints/modals';
import '@js/utilities/forms/formsSubscribers';
import '@js/components/splide/index';
import { enableSpinner, disableSpinner } from '@js/utilities/spinner';
import { cookieHideElementListener } from '@js/utilities/cookieHideElement';
import { topBarController } from '@js/components/topBarController';
import { flashMessageListener } from '@js/components/flashMessage';

import '@js/vendors/alpine';

import '@js/utilities/remoteContent';

// import '@js/listeners/auth/logout';
// import '@js/listeners/auth/loggedIn';
// import '@js/listeners/auth/loggedOut';
// import '@js/listeners/session/exists';
// import '@js/listeners/cart/updateCart';
// import '@js/listeners/cart/updateMiniCart';
// import '@js/listeners/product/addToCart';
// import '@js/listeners/ebook/ebook';
import '@js/listeners/cart/removeFromCart';
import '@js/listeners/cart/addToCartUpsell';
import '@js/listeners/forms/leads';
import '@js/listeners/issue/issue';

import '@js/vendors/alpine/components/engrave';

import { lastViewedListener } from '@js/components/lastViewed';
import { multipleFormFieldsListener } from '@js/utilities/multipleFormFields';
import { ratingListener } from '@js/components/rating';
import { otherFieldsListener } from '@js/utilities/pollOtherField';
import { selectShowAdditionalContentListener } from '@js/utilities/selectShowAdditionalContent';
import { scrollToViewListener } from '@js/utilities/scrollToView';
import { tiltListener } from '@js/utilities/imageTilt';
import { viewportStickyElementsListener } from '@js/utilities/viewportStickyElements';

import { inputFileListener } from '@js/components/inputFile';
import { inputOtherListener } from '@js/utilities/inputOtherController';

import { bootstrapTabHoverListener } from '@js/vendors/bootstrap/bootstrapTabHover';
// import { promotionPopupHandler } from '@js/components/promotionPopup';
import { additionalFormFieldsListener } from '@js/utilities/additionalFormFields';
import { utmsController } from '@js/utilities/utms';
import { scrollToUrlListener } from '../utilities/scrollToUrl';

import('@js/utilities/forms/forms');

import('@js/components/configurator');

lastViewedListener();

(async () => {
    if (document.querySelector('#header-search-input')) {
        const HeaderSearch = await import('@js/components/header-search/HeaderSearch');

        HeaderSearch.default();
    }
})();

(async () => {
    if (document.querySelector('#desktop-navigation')) {
        const desktopNavigationModule = await import('@js/components/desktopNavigation');

        desktopNavigationModule.default();
    }
})();

// async function loadRemoteModals() {
//     console.log('loadRemoteModals');
//     console.log('remoteModals exist');
//     const { remoteModalListener } = await import('@js/utilities/remoteModal');
//     document.addRemoteEventListener(
//         'click',
//         '[data-bs-toggle="modal"][data-bs-remote]',
//         (e) => {
//             remoteModalListener(e.target);
//         }
//     );
// }

// loadRemoteModals();

document.addRemoteEventListener('click', '[data-bs-toggle="modal"][data-bs-remote]', async (e) => {
    const { remoteModalListener } = await import('@js/utilities/remoteModal');
    remoteModalListener(e.target);
});

document.addRemoteEventListener(
    'click',
    '[data-bs-toggle="offcanvas"][data-bs-remote]',
    async (e) => {
        const { remoteOffcanvasListener } = await import('@js/utilities/remoteOffcanvas');

        remoteOffcanvasListener(e.target);
    }
);

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, async () => {
        if (document.querySelector('.js-position-sticky')) {
            const { positionStickyListener } = await import('@js/utilities/positionSticky');
            positionStickyListener();
        }

        multipleFormFieldsListener();
        ratingListener();
        otherFieldsListener();
        selectShowAdditionalContentListener();
        inputFileListener();
        inputOtherListener();
        scrollToViewListener();
        tiltListener();
        viewportStickyElementsListener();
        bootstrapTabHoverListener();
        additionalFormFieldsListener();
    });
});

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((ev) => {
    window.addEventListener(ev, async () => {
        if (document.querySelector('.js-timer')) {
            const timerModule = await import('@js/utilities/countdownTimer');

            timerModule.default();
        }
    });
});

window.addEventListener('DOMContentLoaded', () => {
    cookieHideElementListener();
    topBarController();
    // promotionPopupHandler();
    scrollToUrlListener();
    utmsController();
    flashMessageListener();
    desktopNavigation();
});

// async function loadRemoteOffcanvas() {
//     const remoteOffcanvasListener = await import(
//         '@js/utilities/remoteOffcanvas'
//     );
//     document.addRemoteEventListener(
//         'click',
//         '[data-bs-toggle="offcanvas"][data-bs-remote]',
//         (e) => {
//             remoteOffcanvasListener.default(e.target);
//         }
//     );
// }

// if (
//     document.querySelectorAll('[data-bs-toggle="offcanvas"][data-bs-remote]')
//         .length > 0
// ) {
//     loadRemoteOffcanvas();
// }

// mobileNavigation();
// desktopNavigation();

// (async () => {
//     if (document.querySelector('.js-splide')) {
//         const splideObserver = await import('@js/components/splide');

//         splideObserver.default();
//     }
// })();

window.addEventListener('remoteOffcanvas.loading', (e) => {
    const { offcanvas } = e.detail;

    enableSpinner(offcanvas);
});

window.addEventListener('remoteOffcanvas.loaded', (e) => {
    const { offcanvas } = e.detail;

    disableSpinner(offcanvas);
});

window.addEventListener('remoteModal.loading', (e) => {
    const { modal } = e.detail;

    enableSpinner(modal);
});

window.addEventListener('remoteModal.loaded', (e) => {
    const { modal } = e.detail;

    disableSpinner(modal);
});
